import utils from "@/api/utils";

export default class WorkspaceDesign {
  constructor(api) {
    this.api = api;
  }

  getByUUID(uuid, objectType, workspaceUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/networks/draw/" +
          uuid +
          "?object_type=" +
          objectType +
          "&workspace_uuid=" +
          workspaceUUID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  runNetworkCalculation(calculationEndpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/" + calculationEndpoint, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  labelNetwork(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networks/labellingNetwork", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  fetchValidations(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/validations/")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  runNetworkValidation(
    validationEndpoint,
    technicalLocalUUID,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .get(
        "v1/validations/" +
          validationEndpoint +
          "/technical_local/" +
          technicalLocalUUID,
        {
          headers: utils.getHeaders()
        }
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  exportAsCAD(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networks/cad", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/workspace_design.js